import React from "react";
import FbiWarning from "./FbiWarning";
import cjisLogo from "../assets/logo-cjis.png";
import hipaaLogo from "../assets/logo-hipaa.png";

export default function AuthFooter() {
  return (
    <div className="footer">
      <FbiWarning />
      <div className="footer--logos-container">
        <img src={cjisLogo} height={48} className="grayscale mr-6" alt="cjis-logo" />
        <img src={hipaaLogo} height={40} className="grayscale logo" alt="hipaa-logo" />
      </div>
    </div>
  );
} 